import { Box, Button, createTheme, Dialog, DialogActions, FormControl, InputLabel, MenuItem, Select, ThemeProvider } from '@mui/material';

import { DialogTitle, Typography, withStyles } from '@material-ui/core';

import { withRouter } from 'react-router-dom';

import React, { useState } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import { showToast } from 'modules/layout/layout.actions';
import Spinner from 'modules/common/spinner.component';
import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';
import { getFeeSummaries, postFee } from './fees.actions';
import { GET_FEE_SUMMARIES_FAILURE, POST_FEE_SUCCESS } from './fees.types';

const styles = theme => ({
  wideControl: {
    minWidth: 174
  },
  section: {
    marginBottom: theme.spacing(2)
  }
});

const CreateFeeDialog = props => {
  const { feeStatuses, authorizations, feeTypes } = props;

  const theme = createTheme({
    palette: {
        primary: COLOR_PRIMARY,
        secondary: COLOR_SECONDARY,
        warning: COLOR_WARNING
    }
  });

  let auths = authorizations ? authorizations : [];

  const [isLoadingModal, setIsLoadingModal] = useState(false);

  // Fee Record fields
  const [authId, setAuthId] = useState(0);
  const [feeStatusId, setFeeStatusId] = useState('00000-0000-0000-0000-000000000000');
  const [feeTypeId, setFeeTypeId] = useState('00000-0000-0000-0000-000000000000');

  const createFee = async () => {
    setIsLoadingModal(true);

    const feeInfo = {
        feeRecordId: 0,
        authorizationFileId: authId,
        feeRuleId: 3,
        feeInitiationDate: new Date(),
        priorStatusId: feeStatusId,
        feeStatusId: feeStatusId,
        feeBatchTypeId: feeTypeId,
        feeVoucherId: 0,
        addedBy: 1,
        addedOn: new Date(),
        modifiedBy: 1,
        modifiedOn: new Date()
    }

    const postFeeResp = await props.postFee(feeInfo);
    if (postFeeResp.type === POST_FEE_SUCCESS) {
        const getFeeSummariesResp = await props.getFeeSummaries();
        if (getFeeSummariesResp.type !== GET_FEE_SUMMARIES_FAILURE) {
            props.showToast('Successfully created new fee!', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
            props.onCancel();
        } else {
            props.showToast('Failed to get fee list, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });  
        }
    } else {
      props.showToast('Failed to create fee, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    }

    setIsLoadingModal(false);
  }

  return (
    <ThemeProvider theme={theme}>
        <Dialog open={props.open} fullWidth={false} maxWidth={'lg'}>
            <DialogTitle>New Fee</DialogTitle>
            <Box sx={{ display: 'flex', flexDirection: 'row', padding: '20px', flexWrap: 'wrap', gap: '20px' }}>
                <Box>
                    <FormControl sx={{ marginTop: '6px' }}>
                        <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'vendorTypeId'}>
                            Authorization
                        </InputLabel>
                        <Select
                            labelId={'authId'}
                            key={'authId'}
                            label={'Authorization'}
                            name={'authId'}
                            required={true}
                            disabled={false}
                            value={authId}
                            margin="dense"
                            variant="standard"
                            sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                            onChange={e => {setAuthId(e.target.value)}}
                        >
                            {auths.map(opt => (
                                <MenuItem key={opt.fileId} value={opt.fileId} sx={{ margin: 'dense' }} disabled={false}>
                                    {opt.eeFullName} 
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Typography variant="caption" display="block" color="primary">
                        Required
                    </Typography>
                </Box>
                <Box>
                    <FormControl sx={{ marginTop: '6px' }}>
                        <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'vendorTypeId'}>
                            Fee Status
                        </InputLabel>
                        <Select
                            labelId={'feeStatusId'}
                            key={'feeStatusId'}
                            label={'Fee Status'}
                            name={'feeStatusId'}
                            required={true}
                            disabled={false}
                            value={feeStatusId}
                            margin="dense"
                            variant="standard"
                            sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                            onChange={e => setFeeStatusId(e.target.value)}
                        >
                            {feeStatuses.map(opt => (
                                <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                                    {opt.title} 
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Typography variant="caption" display="block" color="primary">
                        Required
                    </Typography>
                </Box>
                <Box>
                    <FormControl sx={{ marginTop: '6px' }}>
                        <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'vendorTypeId'}>
                            Fee Type
                        </InputLabel>
                        <Select
                            labelId={'feeTypeId'}
                            key={'feeTypeId'}
                            label={'Fee Type'}
                            name={'feeTypeId'}
                            required={true}
                            disabled={false}
                            value={feeTypeId}
                            margin="dense"
                            variant="standard"
                            sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                            onChange={e => setFeeTypeId(e.target.value)}
                        >
                            {feeTypes.map(opt => (
                                <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                                    {opt.title} 
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Typography variant="caption" display="block" color="primary">
                        Required
                    </Typography>
                </Box>
            </Box>

            <DialogActions sx={{ p: '1.25rem' }}>
                {isLoadingModal && <Spinner />}
                {!isLoadingModal && (
                    <>
                        <Button onClick={() => props.onCancel()}>Cancel</Button>
                        <Button
                            onClick={createFee}
                            color="primary"
                            type="submit"
                            variant="contained"
                        >
                            Create Fee Record
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    </ThemeProvider>
  );
};

const mapStateToProps = state => {
  const { countries, provinces, addressTypes, clientStatusTypes, industries } = state.enumerations.allEnums;
  
  return {
    countries,
    provinces,
    addressTypes,
    clientStatusTypes,
    industries,
  };
};

export default compose(
  withStyles(styles),
  withRouter,
  connect(mapStateToProps, {
    postFee,
    getFeeSummaries,
    showToast
  }),
)(CreateFeeDialog);
